import { Button, SimpleCallback, SimpleText } from 'platform-components';
import React from 'react';

interface Props {
    onLockedButtonClick: SimpleCallback;
}

const CertificateCardButtonLocked = (props: Props) => {
    const { onLockedButtonClick } = props;

    return (
        <Button className="certificate-card__button" onClick={onLockedButtonClick} view={Button.VIEW.SECONDARY}>
            <SimpleText id="teacherLK.card.buttonText.locked" />
        </Button>
    );
};

export default CertificateCardButtonLocked;
